import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

import { API_URL } from '../utils/api';

function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from hash - check multiple sources for mobile compatibility
        const fullUrl = window.location.href;
        const hash = window.location.hash || '';
        let sessionId = null;

        // Try extracting from hash fragment
        const hashMatch = hash.match(/session_id=([^&]+)/);
        if (hashMatch) {
          sessionId = hashMatch[1];
        }

        // Fallback: try extracting from full URL (some mobile browsers handle hash differently)
        if (!sessionId) {
          const urlMatch = fullUrl.match(/session_id=([^&]+)/);
          if (urlMatch) {
            sessionId = urlMatch[1];
          }
        }

        // Fallback: check query params
        if (!sessionId) {
          const params = new URLSearchParams(window.location.search);
          sessionId = params.get('session_id');
        }

        if (!sessionId) {
          console.error('No session_id found in URL:', fullUrl);
          navigate('/login', { replace: true });
          return;
        }

        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const response = await axios.post(
          `${API_URL}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const userData = response.data.user;
        const sessionToken = response.data.session_token;

        // Store token in localStorage for cross-origin and mobile environments
        if (sessionToken) {
          localStorage.setItem('session_token', sessionToken);
        }

        setUser(userData);
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error?.response?.data || error.message);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#16A34A] mx-auto mb-4"></div>
        <p className="text-gray-400">Authenticating...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
